import { Component, signal, computed, inject, effect } from '@angular/core';
import { Field, PSIC_COMPONENTS } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { Store } from '@ngrx/store';
import { MatIconModule } from '@angular/material/icon';
import { ConnectService } from '../services/amazon-connect.service';
import { setUserAuthenticated } from '../store/selection/selection.actions';

@Component({
    selector: 'app-user-authenticated',
    imports: [...PSIC_COMPONENTS, MatIconModule],
    templateUrl: './user-authenticated.component.html',
    styleUrl: './user-authenticated.component.scss',
})
export class UserAuthenticatedComponent {
    public userAuthenticated = signal(false);
    field: Field = new Field({
        hintText: 'yes',
        disabled: false,
        value: false,
    });
    private store = inject(Store);
    private connectService = inject(ConnectService);
    policySignal = this.store.selectSignal((state: any) => state.policy);

    userAuthEffect = effect(() => {
        const attrs = this.connectService.attributes;
        const contactAuth = attrs?.userAuthenticated ?? attrs?.UserAuthenticated;
        if (contactAuth !== undefined && contactAuth !== null) {
            const isAuth = contactAuth === true || contactAuth === 'true' || contactAuth === '1';
            this.userAuthenticated.set(isAuth);
            this.field.value = isAuth;
            // Seed the store with the API-derived value so confirmSelection always
            // has an authoritative value even if the CSR never touches the toggle.
            this.store.dispatch(setUserAuthenticated({ isAuthenticated: isAuth }));
            return;
        }

        const policy = this.policySignal();
        if (policy?.policySnapshot?.userAuthenticated) {
            const isAuth = policy.policySnapshot.userAuthenticated.value;
            this.userAuthenticated.set(isAuth);
            this.field.value = isAuth;
            this.store.dispatch(setUserAuthenticated({ isAuthenticated: isAuth }));
        }
    });

    isAuthenticated = computed(() => this.userAuthenticated());

    onToggleChange(value: any) {
        const newValue = !this.userAuthenticated();
        this.userAuthenticated.set(newValue);
        this.field.value = newValue;
        // Persist the manual override so other components (e.g. call-intent) can read it
        this.store.dispatch(setUserAuthenticated({ isAuthenticated: newValue }));
    }
}
